module.exports = __webpack_public_path__ + "images/external_images/img/demo/hotel/room-6.jpg";